import $ from 'jquery'
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock'
import component from './_component'
import focusLoopStack from './_focusLoopStack.js'

/*
■ヘッダの処理

▼PC
・tabキーでのフォーカスで子メニューを開く
・tabキーでの子メニュー内の移動
・tabキーで子メニュー外に出た場合、子メニューを閉じる
・検索メニューなど、クリックでオープンするメニューもある

▼SP
・ハンバーガーボタンでGNAVをモーダル状態で開く
・子メニューはトグルで開く
・モーダルの上にさらにモーダル的に開くコンテンツがある可能性もあり
　その場合以下でセットアップ
  modalInit($target（モーダルコンテンツ）, $thisBtn（開いたボタン）, $humbergerBtn（なければ空）, closeFunction（閉じる処理）);

*/

// フォーカスで開くタイプの場合 true, クリックの場合 false
var isHoverType = true
// var isHoverType = false;

// gnavの切り替えタイミング
// PCSPで切り替えず、常にハンバーガーにする場合は '--all-match' にする
// --to-lgは0～1023px, --all-matchは0px～
var gnavMatchMedia = '--to-lg'
// var gnavMatchMedia = '--all-match';

var isHeaderFixed = false

var onGnav = false

// .js-header_toggle-targetのariaの状態リセット
var headerAriaSet = function () {
  var $this = $('.js-header_toggle-target')
  var id = $this.attr('id')
  var $controls = $('.js-header_toggle-open').filter(
    '[aria-controls="' + id + '"]'
  )

  if (component.matchMedia[gnavMatchMedia].matches) {
    // SP
    $this.attr({
      'aria-hidden': 'true',
    })
    $controls.attr({
      'aria-expanded': 'false',
    })
  } else {
    // PC
    $this.attr({
      'aria-hidden': 'false',
    })
    $controls.attr({
      'aria-expanded': 'true',
    })
  }
}

// .js-gnavのariaセット
var gnavAriaSet = function () {
  $('.js-gnav')
    .find('.js-gnav_item')
    .each(function (itemIndex) {
      $(this)
        .find('.js-gnav_link')
        .attr({
          role: 'button',
          'aria-expanded': 'false',
          'aria-controls': 'gnav_contents_' + itemIndex,
        })
      $(this)
        .find('.js-gnav_contents')
        .attr({
          id: 'gnav_contents_' + itemIndex,
          'aria-hidden': 'true',
        })
    })
}

var headerReset = function (isDirect) {
  // 全体をリセット
  headerToggleAllReset(isDirect)

  // 子メニューを閉じる
  gnavChildrenMenuClose($('.js-gnav'), {
    isDirect: isDirect,
    isSlide: !isDirect,
  })

  // フォーカスループコンテンツクリア
  focusLoopStack.delById('humbergerMenu')
}

var modalClose = function () {
  // 最上位のモーダル要素
  var modal = focusLoopStack.stack.pop()
  var $currentTarget = $(modal.targetEl)
  var $thisBtn = $(modal.openBtnEl)

  headerToggleClose($thisBtn, $currentTarget, function () {
    if ($thisBtn && $thisBtn[0]) {
      $thisBtn[0].focus()
    }
  })
}

// ページ最上部へアニメーションなしで移動
//
// htmlに scroll-behavior: smooth が効いているため、$(window).scrollTop(0) や
// window.scrollTo(0, 0) ではスクロールがアニメーションになる。
// 一方で html.is-gnav-open の overflow:hidden が付くと html がスクロール
// コンテナではなくなり、.p-header の position:sticky が無効になって
// 静的位置（＝スクロールした分だけ画面外の上方）へ取り残される。
// 結果、アニメーションが終わるまでドロワー上端(top: 76px)より上に帯状の隙間が
// でき、そこにページ内のコンテンツが見えてしまう。
//
// behavior: 'instant' はCSSの scroll-behavior を明示的に打ち消す指定なので、
// これで同期的に最上部へ移動させて隙間自体を発生させない。
var scrollToTopImmediately = function () {
  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  } catch (e) {
    // ScrollToOptions / 'instant' 非対応ブラウザ向けフォールバック
    window.scrollTo(0, 0)
  }
}

var modalInit = function ($target, $thisBtn, $humbergerBtn, closeFunction) {
  // フォーカスループ開始
  // 開いたモーダル記録
  /*
  {
    id: string
    targetEl: HTMLElement
    openBtnEl: HTMLElement
    afterFocusEl: HTMLElement
    addFocus: {
      el: HTMLElement
      matchMedia: --to-md | --md | --lg | etc
    } <Array>
    closeFunction: function
  }
  */
  focusLoopStack.stack.push({
    id: 'humbergerMenu',
    type: 'globalMenu',
    targetEl: $target[0],
    openBtnEl: $thisBtn[0],
    afterFocusEl: null,
    addFocus: [{ el: $humbergerBtn[0] }],
    closeFunction: closeFunction,
  })

  // scroll lock
  disableBodyScroll($target[0])
}

// 閉じる処理 動作ボタン, モーダルコンテンツ, コールバック（modalCloseから利用）
var headerToggleClose = function ($thisBtn, $target, callback) {
  var $humbergerBtn = $('.js-header_toggle-open')
  $humbergerBtn.removeClass('is-active')
  $humbergerBtn.addClass('is-close-enter')
  $humbergerBtn.attr({
    'aria-expanded': 'false',
  })

  $('html').removeClass('is-gnav-open')
  $('html').removeClass('is-gnav-hover-open')

  $('.p-header__overlay').fadeOut(150, function () {
    $(this).css({ display: '' })
  })

  $target.slideUp(150, function () {
    $humbergerBtn.removeClass('is-close-enter')
    $target.css({ display: '' })
    $target.removeClass('is-active')
    $target.attr({
      'aria-hidden': 'true',
    })
  })

  if (callback && typeof callback === 'function') {
    callback()
  }

  enableBodyScroll($target[0])

  focusLoopStack.delById('humbergerMenu')
}

var headerToggleOpen = function ($thisBtn, $target) {
  var $humbergerBtn = $('.js-header_toggle-open')

  // overlayの表示状態により処理変更
  var $overlay = $('.p-header__overlay')
  var overlayHidden = $overlay.is(':hidden')

  // メニューリセット
  headerReset(true)

  // ヘッダをfixedにする場合、以下はコメントアウト
  // overflow:hidden の付与とドロワー表示より先に、アニメーションなしで最上部へ移動させる
  // （後から動かすと、移動が完了するまでヘッダーが表示されない帯ができてしまう）
  if (!isHeaderFixed) {
    scrollToTopImmediately()
  }

  // html
  $('html').addClass('is-gnav-open')

  // overlay
  // 元の表示状態によりフェードorダイレクト
  if (overlayHidden) {
    $overlay.show().css({ opacity: 0 })
    $overlay.animate({ opacity: 1 }, 150, function () {
      $target.css({ opacity: '' })
    })
  } else {
    $overlay.show()
  }

  // ヘッダーメニューコンテンツ表示
  /*
  $target.show().css({opacity: 0});
  $target.animate({opacity: 1}, 150, function() {
    $target.css({opacity: ''});
  });
  */
  $target.slideDown(150, function () {
    $target.addClass('is-active')
    $target.css({ display: '' })
  })

  // ボタン処理
  $humbergerBtn.addClass('is-active')
  $humbergerBtn.attr({ 'aria-expanded': 'true' })
  $target.attr({ 'aria-hidden': 'false' })

  // モーダルオープン処理
  modalInit($target, $thisBtn, $humbergerBtn, modalClose)
}

var headerToggleAllReset = function (isDirect) {
  $('html').removeClass('is-gnav-open')
  $('html').removeClass('is-gnav-hover-open')

  if (isDirect) {
    $('.p-header__overlay').hide()
    $('.js-header_toggle-open').removeClass('is-active')
    $('.js-header_toggle-target').hide().css({ display: '' })
  } else {
    $('.js-header_toggle-target').slideUp(150, function () {
      $('.js-header_toggle-open').removeClass('is-active')
      $('.js-header_toggle-target').css({ display: '' })
    })

    $('.p-header__overlay').fadeOut(150, function () {
      $(this).css({ display: '' })
    })
  }

  headerAriaSet()
  clearAllBodyScrollLocks()
}

var gnavChildrenMenuStateChange = function ($el, isOpen) {
  var $gnavLink = $el.find('.js-gnav_link')
  var $gnavContents = $el.find('.js-gnav_contents')
  if (isOpen) {
    $gnavLink.attr({ 'aria-expanded': 'true' })
    $gnavContents.attr({ 'aria-hidden': 'false' })
    $gnavLink.addClass('is-active')
    $el.addClass('is-active')
  } else {
    $gnavLink.attr({ 'aria-expanded': 'false' })
    $gnavContents.attr({ 'aria-hidden': 'true' })
    $gnavLink.removeClass('is-active')
    $el.removeClass('is-active')
  }
}

var gnavChildrenMenuClose = function ($box, arg) {
  /*
  arg = {
    isDirect: boolean,
    isFade: boolean,
    isSlide: boolean,
    callback: function,
    focusAfterClosed: HTMLElement,
    isOpenGnav: boolean,
  }
  */
  var $gnavItem = $box.hasClass('js-gnav_item')
    ? $box
    : $box.find('.js-gnav_item')

  // state変更(ariaなど)
  gnavChildrenMenuStateChange($gnavItem, false)

  // 表示切り替え
  if (arg.isFade) {
    $gnavItem.stop(true, true).find('.js-gnav_contents').fadeOut(150)
  } else if (arg.isDirect) {
    $gnavItem.find('.js-gnav_contents').hide()
    if (!onGnav) {
      $('.p-header__overlay').hide()
      $('html').removeClass('is-gnav-hover-open')
    }
  } else {
    $gnavItem.find('.js-gnav_contents').slideUp(150, function () {})

    if (!component.matchMedia[gnavMatchMedia].matches && !arg.isOpenGnav) {
      // PC & 他のGnavが開いている場合はoverlayを消さない
      $('.p-header__overlay').fadeOut(150, function () {})
      $('html').removeClass('is-gnav-hover-open')
    }
  }

  if (arg.focusAfterClosed) {
    // focusinが発火してしまうため一旦フォーカス移動はしない
    // arg.focusAfterClosed.focus({preventScroll: true});
  }
}

var gnavChildrenMenuOpenTimer = 0
var gnavChildrenMenuOpen = function ($box, arg) {
  /*
  arg = {
    isDirect: boolean,
    isFade: boolean,
    isSlide: boolean,
    isOpenGnav: boolean,
    isOhterClose: boolean,
  }
  */
  var $gnavItem = $box.hasClass('js-gnav_item')
    ? $box
    : $box.find('.js-gnav_item')
  var waitTime = 0

  clearTimeout(gnavChildrenMenuOpenTimer)

  if (arg.isOhterClose) {
    // SP時はトグルになるため、自分以外も開いたまま
    // PC時は自分以外は閉じる
    waitTime = arg.isOpenGnav ? 100 : 0
    gnavChildrenMenuClose($('.js-gnav'), arg)
  }

  // 表示切り替え
  if (arg.isFade) {
    gnavChildrenMenuOpenTimer = setTimeout(function () {
      $gnavItem.stop(true, true).find('.js-gnav_contents').fadeIn(150)
      $('.p-header__overlay')
        .stop()
        .fadeIn(150, function () {})
      $('html').addClass('is-gnav-hover-open')
    }, waitTime)
  } else if (arg.isDirect) {
    $gnavItem.find('.js-gnav_contents').show()
    $('.p-header__overlay')
      .stop()
      .fadeIn(0, function () {})
    $('html').addClass('is-gnav-hover-open')
  } else if (arg.isSlide) {
    gnavChildrenMenuOpenTimer = setTimeout(function () {
      $gnavItem.find('.js-gnav_contents').slideDown(150, function () {})
      $('.p-header__overlay')
        .stop()
        .fadeIn(150, function () {})
      $('html').addClass('is-gnav-hover-open')
    }, waitTime)
  }

  // state変更(ariaなど)
  gnavChildrenMenuStateChange($gnavItem, true)
}

// Escキーで閉じる
var escapeClose = function ($this, focusAfterClosed) {
  $(document).off('keydown.gnavChildrenEscapeClose')
  $(document).on('keydown.gnavChildrenEscapeClose', function (e) {
    if (e.key === 'Escape') {
      e.preventDefault()
      gnavChildrenMenuClose($this, {
        isSlide: true,
        focusAfterClosed: focusAfterClosed,
      })
    }
  })
}

// PC Hover処理
var onGnavLinkHoverOpen = function (e) {
  var $this = $(this)
  var $parentGnav = $this.closest('.js-gnav')
  clearTimeout($this.data('mouseOutTimer'))

  if ($this.find('.js-gnav_link').filter('[aria-expanded="true"]')[0]) {
    // 開いている場合stop
    return
  }

  var isOpenGnav = !!$parentGnav
    .find('.js-gnav_item')
    .not($this)
    .find('.js-gnav_link')
    .filter('[aria-expanded="true"]')[0]

  setTimeout(function () {
    // onGnavの切り替わりを待つためsetTimeout 0
    var waitTime =
      $(e.relatedTarget).hasClass('js-gnav') ||
      $(e.relatedTarget).closest('.js-gnav')[0]
        ? 150
        : 250
    var timer = setTimeout(function () {
      var isOpen = !!$parentGnav
        .find('.js-gnav_link')
        .filter('[aria-expanded="true"]')[0]

      if (isOpen) {
        gnavChildrenMenuOpen($this, {
          isFade: true,
          isOhterClose: true,
          isOpenGnav: isOpenGnav,
        })
      } else {
        gnavChildrenMenuOpen($this, {
          isSlide: true,
          isOhterClose: true,
          isOpenGnav: isOpenGnav,
        })
      }
    }, waitTime)

    $this.data('mouseInTimer', timer)

    escapeClose($this, $this.find('.js-gnav_link')[0])
  }, 0)
}

var onGnavLinkHoverClose = function (e) {
  var $this = $(this)
  var $parentGnav = $this.closest('.js-gnav')

  clearTimeout($(this).data('mouseInTimer'))

  var timer = setTimeout(function () {
    // 開いた状態なら
    if ($this.find('.js-gnav_link').filter('[aria-expanded="true"]')[0]) {
      // 他のgnavが開いていれば
      if (
        $parentGnav
          .find('.js-gnav_item')
          .not($this)
          .find('.js-gnav_link')
          .filter('[aria-expanded="true"]')[0]
      ) {
        gnavChildrenMenuClose($this, {
          isFade: true,
        })
      } else {
        gnavChildrenMenuClose($this, {
          isSlide: true,
        })
      }
    }

    $(document).off('keydown.gnavChildrenEscapeClose')
  }, 400)

  $(this).data('mouseOutTimer', timer)
}

// PC Click処理
var onGnavLinkOutsideClick = function (e) {
  if (!e.target.closest('.p-header__global')) {
    // 外側
    gnavChildrenMenuClose($('.js-gnav'), {
      isSlide: true,
    })
  }
}

var onGnavLinkClickOpen = function (e) {
  var $this = $(this)
  var $parentGnav = $this.closest('.js-gnav')
  var isOpenGnav = !!$parentGnav
    .find('.js-gnav_item')
    .not($this)
    .find('.js-gnav_link')
    .filter('[aria-expanded="true"]')

  gnavChildrenMenuOpen($this, {
    isSlide: true,
    isOhterClose: true,
    isOpenGnav: isOpenGnav,
  })

  $(document).on('click.gnavLinkOutsideClick', onGnavLinkOutsideClick)
  escapeClose($this, $this.find('.js-gnav_link')[0])
}

var onGnavLinkClickClose = function (e) {
  var $this = $(this)

  gnavChildrenMenuClose($this, {
    isSlide: true,
  })

  $(document).off('click.gnavLinkOutsideClick')
  $(document).off('keydown.gnavChildrenEscapeClose')
}

function init() {
  // SP版、PC版への切り替え時リセット
  component.matchMedia[gnavMatchMedia].addListener(function () {
    headerReset(true)
  })

  // GNAV　SP時用トグル処理
  $(document).on('click', '.js-gnav_link', function (e) {
    if (component.matchMedia[gnavMatchMedia].matches) {
      // SP
      e.preventDefault()

      var $box = $(this).closest('.js-gnav_item')
      if ($box.hasClass('is-active')) {
        gnavChildrenMenuClose($box, {
          isSlide: true,
        })
      } else {
        gnavChildrenMenuOpen($box, {
          isSlide: true,
          isOhterClose: false,
        })
      }
    }
  })

  // GNAVメニュー　ホバータイプ用
  $(document).on('mouseenter focusin', '.js-gnav', function (e) {
    onGnav = true
  })
  $(document).on('mouseleave focusout', '.js-gnav', function (e) {
    onGnav = false
  })

  if (isHoverType) {
    // GNAVメニュー　ホバータイプの場合
    $(document).on('mouseenter focusin', '.js-gnav_item', function (e) {
      if (!component.matchMedia[gnavMatchMedia].matches) {
        // PC
        onGnavLinkHoverOpen.call(this, e)
      }
    })
    $(document).on('mouseleave focusout', '.js-gnav_item', function (e) {
      if (!component.matchMedia[gnavMatchMedia].matches) {
        // PC
        onGnavLinkHoverClose.call(this, e)
      }
    })
  } else {
    // GNAVメニュー　クリックタイプの場合
    $(document).on('click', '.js-gnav_link', function (e) {
      if (!component.matchMedia[gnavMatchMedia].matches) {
        // PC
        e.preventDefault()
        var $parent = $(this).closest('.js-gnav_item')
        if ($parent.hasClass('is-active')) {
          onGnavLinkClickClose.call($parent[0], e)
        } else {
          onGnavLinkClickOpen.call($parent[0], e)
        }
      }
    })
  }

  // GNAVメニュー内に閉じるボタンを入れる場合
  $(document).on('click', '.js-gnav_close', function (e) {
    gnavChildrenMenuClose($('.js-gnav'), {
      isSlide: true,
    })
  })

  // js-header_toggle-closeと一緒？使っていない
  $(document).on('click', '.js-header_close', function (e) {
    headerReset(false)
  })

  // ハンバーガーボタン
  $(document).on('click', '.js-header_toggle-open', function (e) {
    e.preventDefault()
    var $this = $(this)
    var $target = $('#' + $this.attr('aria-controls'))

    if ($this.hasClass('is-active')) {
      headerToggleClose($this, $target)
    } else {
      headerToggleOpen($this, $target)
    }
  })

  // ハンバーガー内にCLOSEボタンを入れる場合
  $(document).on('click', '.js-header_toggle-close', function (e) {
    var id = $(this).closest('.js-header_toggle-target').attr('id')
    $('.js-header_toggle-open[aria-controls="' + id + '"]')
      .eq(0)
      .trigger('click')
  })

  // GNAV内からのアンカーリンクでOPEN状態をリセット
  $(document).on(
    'click',
    '.js-header_toggle-target .js-anchor[href^="#"]',
    function (e) {
      headerReset()
    }
  )
}

function ready() {
  // セットアップ
  headerAriaSet()
  gnavAriaSet()
}

export default {
  init() {
    init()
    $(function () {
      ready()
    })
  },
}
